import colors from "tailwindcss/colors";
import { PerformanceAssessmentChartLabelInput } from "types/graphql-schema";

import { ChartLabel } from "./types";

export const nineBoxBg = (percentage: number) => {
  if (percentage >= 40) {
    return colors.purple[600];
  }
  if (percentage >= 25) {
    return colors.purple[400];
  }
  if (percentage >= 10) {
    return colors.purple[300];
  }
  if (percentage > 0) {
    return colors.purple[200];
  }
  return colors.gray[200];
};
export const nineBoxTextColor = (percentage: number) => {
  if (percentage >= 25) {
    return colors.white;
  }
  if (percentage >= 10) {
    return colors.gray[800];
  }
  if (percentage > 0) {
    return colors.gray[600];
  }
  return colors.gray[500];
};

export const getNineBoxChartLabel = (
  chartLabels: ChartLabel[] | PerformanceAssessmentChartLabelInput[],
  questionOneId: number,
  questionOneIntegerAnswer: number,
  questionTwoId?: number,
  questionTwoIntegerAnswer?: number,
) => {
  if (!questionTwoId) {
    const singleQuestionLabels = chartLabels.filter((label) => {
      if ("questionOneId" in label) {
        return !label.questionTwoId;
      }
      return !label.questionTwo;
    });
    return singleQuestionLabels.find((label) => {
      if ("questionOneId" in label) {
        return (
          label.questionOneId === questionOneId &&
          questionOneIntegerAnswer === label.questionOneIntegerAnswer
        );
      }
      return (
        label.questionOne.id === questionOneId &&
        questionOneIntegerAnswer === label.questionOneIntegerAnswer
      );
    });
  }

  return chartLabels.find((label) => {
    if ("questionOneId" in label) {
      return (
        label.questionTwoId &&
        ((label.questionOneId === questionOneId &&
          questionOneIntegerAnswer === label.questionOneIntegerAnswer &&
          label.questionTwoId === questionTwoId &&
          questionTwoIntegerAnswer === label.questionTwoIntegerAnswer) ||
          (label.questionOneId === questionTwoId &&
            questionTwoIntegerAnswer === label.questionOneIntegerAnswer &&
            label.questionTwoId === questionOneId &&
            questionOneIntegerAnswer === label.questionTwoIntegerAnswer))
      );
    }
    return (
      label.questionTwo &&
      ((label.questionOne.id === questionOneId &&
        questionOneIntegerAnswer === label.questionOneIntegerAnswer &&
        label.questionTwo.id === questionTwoId &&
        questionTwoIntegerAnswer === label.questionTwoIntegerAnswer) ||
        (label.questionOne.id === questionTwoId &&
          questionTwoIntegerAnswer === label.questionOneIntegerAnswer &&
          label.questionTwo.id === questionOneId &&
          questionOneIntegerAnswer === label.questionTwoIntegerAnswer))
    );
  });
};
